<wbo-edit-page #editPage (saved)="saved()" (saving)="onSave($event)"
               [hideClone]="true" [exitRoute]="exitRoute" [title]="model.data.name" [formGroup]="editPage.formGroup">

    <wbo-bi-server-status-indicator *ngIf="serverStatusModel.isInitialising()"></wbo-bi-server-status-indicator>

    <div *ngIf="serverStatusModel.isInitialised()" class="pivot">
        <div class="pivot-edit">
            <div class="pivot-edit-form">
                <fui-rows>
                    <fui-row>
                        <wbo-text-edit-control [(ngModel)]="model.data.name" formControlName="name">
                        </wbo-text-edit-control>
                    </fui-row>
                    <fui-row>
                        <wbo-single-select-edit-control [(ngModel)]="cubeName" formControlName="cubeName"
                                                        [allowClearSelectionOption]="false"
                                                        [readonlyOnEdit]="true"
                                                        (onSelect)="onChangeCubeName()">
                            <wbo-select-options>
                                <wbo-select-option [value]="'ProductSales'"
                                                   label="wbo.bi-dashboard.common.cube.productSales"></wbo-select-option>
                                <wbo-select-option [value]="'KVDDisplay'"
                                                   label="wbo.bi-dashboard.common.cube.kvdDisplay"></wbo-select-option>
                                <wbo-select-option [value]="'KVDItems'"
                                                   label="wbo.bi-dashboard.common.cube.kvdItems"></wbo-select-option>

                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-row>
                    <fui-row>
                        <wbo-checkbox-edit-control [(ngModel)]="model.data.public" formControlName="public"
                                                   [readonly]="!canPublish">
                        </wbo-checkbox-edit-control>
                    </fui-row>
                    <fui-row *ngIf="!fullEdit">
                        <fui-inline-warning
                            [title]="'wbo.bi.common.small-screen-edit.info.title'"
                            [message]="'wbo.bi.common.small-screen-edit.info.message'">
                        </fui-inline-warning>
                    </fui-row>
                </fui-rows>
            </div>
            <div class="pivot-edit-data" *ngIf="fullEdit">
                <div class="pivot-edit-data-attributes">
                    <div class="pivot-edit-data-attributes-pane">
                        <wbo-bi-draggable-attributes-list [attributes]="filteredAttributes"
                                                          [title]="'wbo.bi-pivot-grid.edit.field-set.fields'">
                        </wbo-bi-draggable-attributes-list>
                    </div>
                </div>
                <div class="pivot-edit-data-selections">
                    <div class="pivot-edit-data-selections-pane">
                        <wbo-bi-drop-container (onDrop)="addColumnAt($event, columnAttributes.length - 1)"
                                               [dropAreaLabel]="'wbo.bi-pivot-grid.edit.field-set.drop-column-fields-here'"
                                               [dropZones]="['dimension']"
                                               [icon]="'axes'"
                                               [showDropArea]="columnAttributes.length == 0"
                                               [title]="'wbo.bi-pivot-grid.edit.field-set.columns'">

                            <wbo-bi-draggable-member-select (onDrop)="addColumnAt($event, i)"
                                                            (removed)="removeColumn(i, $event)"
                                                            (selectedFilterMembersChange)="selectFilterMembers(item, $event)"
                                                            *ngFor="let item of columnAttributes; let i = index"
                                                            [cubeDefinition]="cubeDefinition"
                                                            [data]="item"
                                                            [dropZones]="['dimension']"
                                                            [orderable]="true"
                                                            [selectedFilterMembers]="allSelectedFilterMembers"></wbo-bi-draggable-member-select>

                        </wbo-bi-drop-container>

                        <wbo-bi-drop-container (onDrop)="addRowAt($event, rowAttributes.length - 1)"
                                               [dropAreaLabel]="'wbo.bi-pivot-grid.edit.field-set.drop-row-fields-here'"
                                               [dropZones]="['dimension']"
                                               [icon]="'axes'"
                                               [message]="isMandatoryAttributeSelected() ? undefined : mandatoryAttributeFieldMessage"
                                               [showDropArea]="rowAttributes.length == 0"
                                               [title]="'wbo.bi-pivot-grid.edit.field-set.rows'">

                            <wbo-bi-draggable-member-select (onDrop)="addRowAt($event, i)"
                                                            (removed)="removeRow(i, $event)"
                                                            (selectedFilterMembersChange)="selectFilterMembers(item, $event)"
                                                            *ngFor="let item of rowAttributes; let i = index"
                                                            [cubeDefinition]="cubeDefinition"
                                                            [data]="item"
                                                            [dropZones]="['dimension']"
                                                            [orderable]="true"
                                                            [selectedFilterMembers]="allSelectedFilterMembers"></wbo-bi-draggable-member-select>

                        </wbo-bi-drop-container>

                        <wbo-bi-drop-container (onDrop)="addMeasureAt($event, measureAttributes.length - 1)"
                                               [dropAreaLabel]="'wbo.bi-pivot-grid.edit.field-set.drop-value-fields-here'"
                                               [dropZones]="['measure']"
                                               [icon]="'sum'"
                                               [showDropArea]="measureAttributes.length == 0"
                                               [title]="'wbo.bi-pivot-grid.edit.field-set.values'">

                            <wbo-bi-draggable-member-select (onDrop)="addMeasureAt($event, i)"
                                                            (removed)="removeMeasure(i)"
                                                            *ngFor="let item of measureAttributes; let i = index"
                                                            [cubeDefinition]="cubeDefinition"
                                                            [data]="item"
                                                            [dropZones]="['measure']"
                                                            [label]="item.value"
                                                            [orderable]="true"></wbo-bi-draggable-member-select>

                        </wbo-bi-drop-container>

                        <wbo-bi-drop-container (onDrop)="addFilterAt($event, filterAttributes.length - 1)"
                                               [dropAreaLabel]="'wbo.bi-pivot-grid.edit.field-set.drop-filter-fields-here'"
                                               [dropZones]="['dimension']"
                                               [message]="isMandatoryAttributeSelected() ? undefined : mandatoryAttributeFilterMessage"
                                               [icon]="'axes'"
                                               [showDropArea]="filterAttributes.length == 0"
                                               [title]="'wbo.bi-pivot-grid.edit.field-set.filters'">

                            <div class="date-range">
                                <fui-pill-form-context>
                                    <wbo-date-range-single-select-search-control
                                        (valueChange)="pivotGridDateRange = $event"
                                        [cube]="cubeName"
                                        [label]="'wbo.bi.search.field.dateRangeRef.label'"
                                        [placeholder]="'wbo.bi.search.field.dateRangeRef.placeholder'"
                                        [removable]="false"
                                        [value]="pivotGridDateRange">
                                    </wbo-date-range-single-select-search-control>
                                </fui-pill-form-context>
                            </div>

                            <wbo-bi-draggable-member-select (onDrop)="addFilterAt($event, i)"
                                                            (removed)="removeFilter(i, $event)"
                                                            (selectedFilterMembersChange)="selectFilterMembers(item, $event)"
                                                            *ngFor="let item of filterAttributes; let i = index"
                                                            [cubeDefinition]="cubeDefinition"
                                                            [data]="item"
                                                            [dropZones]="['dimension']"
                                                            [orderable]="false"
                                                            [selectedFilterMembers]="filterSelectedFilterMembers"></wbo-bi-draggable-member-select>

                        </wbo-bi-drop-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="pivot-view">
            <wbo-bi-view-header [restrictions]="pivotGridModel.restriction$ | async"
                                [rowsTruncated]="pivotGridModel.data?.rowsTruncated"
                                [columnsTruncated]="pivotGridModel.data?.columnsTruncated"
                                (refresh)="refresh()" [showRefresh]="true">
            </wbo-bi-view-header>

            <wbo-bi-pivot-grid [height]="gridHeight"></wbo-bi-pivot-grid>
        </div>
    </div>
</wbo-edit-page>
